import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      style={{
        background: "#111111",
        color: "#aaa",
        padding: "1.5rem 1rem",
        textAlign: "center",
        fontSize: "0.85rem",
        marginTop: 0,
        borderTop: "1px solid #1d9e75",
      }}
    >
      <div style={{ marginBottom: "0.5rem" }}>
        © {new Date().getFullYear()} PaceWerks
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "1rem",
          flexWrap: "wrap",
        }}
      >
        <a href="/legal#privacy" className="footer-link">
          Privacy Policy
        </a>
        <a href="/legal#terms" className="footer-link">
          Terms of Use
        </a>
        <a href="/legal#disclaimer" className="footer-link">
          Disclaimer
        </a>
        <Link to="/about" className="footer-link">
          About
        </Link>
        <Link to="/contact" className="footer-link">
          Contact
        </Link>
        <Link to="/feedback" className="footer-link">
          Feedback
        </Link>
      </div>
    </footer>
  );
}
